import { css, Stack, styled, Typography } from '@mui/material';

export const Container = styled(Stack)(({ theme }) => ({
  gap: 24,
  width: '100%',
  boxSizing: 'border-box',
  padding: '0 16px',
  justiSelf: 'center',

  [theme.breakpoints.up('tablet')]: {
    padding: 0,
    width: 360,
  },

  '& .MuiInputBase-root': {
    height: 52,
  },
}));

export const Header = styled(Stack)({
  alignItems: 'flex-start',
  gap: 8,
});

export const Title = styled(Typography)(({ theme }) => ({
  ...theme.typography['title-3-sb'],
  color: theme.palette.grey[900],

  [theme.breakpoints.up('mobileMedium')]: {
    ...theme.typography['title-2-sb'],
  },
}));

export const SSubtitle = styled(Typography)(
  () => css`
    text-align: left;
  `,
);
